import RootState from "store/state";
import useDirectory from "./useDirectory";
import loadExternalDirectoryContacts from "./loadExternalDirectoryContacts";

type Returns = [
    RootState["directory"]["externalDirectory"]["contacts"],
    RootState["directory"]["externalDirectory"]["isLoading"]
];

export default function useExternalDirectoryContacts() {
    const { externalDirectory } = useDirectory();

    const { contacts, isLoading } = externalDirectory;

    loadExternalDirectoryContacts();

    return [contacts, isLoading] as Returns;
}
